import { render, staticRenderFns } from "./MaterialDayCheckbox.vue?vue&type=template&id=6af33d80&scoped=true&"
import script from "./MaterialDayCheckbox.vue?vue&type=script&lang=js&"
export * from "./MaterialDayCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDayCheckbox.vue?vue&type=style&index=0&id=6af33d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af33d80",
  null
  
)

export default component.exports